import script from "./menuPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuPage.vue?vue&type=script&setup=true&lang=ts"

import "./menuPage.vue?vue&type=style&index=0&id=ef7aca6e&lang=scss&scoped=true"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef7aca6e"]])

export default __exports__